import { render } from "./manual.vue?vue&type=template&id=53a2e92d&scoped=true"
import script from "./manual.vue?vue&type=script&lang=js"
export * from "./manual.vue?vue&type=script&lang=js"

import "./manual.vue?vue&type=style&index=0&id=53a2e92d&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a2e92d"]])

export default __exports__